import { Pipe, PipeTransform } from '@angular/core';
import { Breadcrumb } from '@agilox/ui-common';

@Pipe({
	name: 'breadcrumbEllipsis',
})
export class BreadcrumbEllipsisPipe implements PipeTransform {
	/**
	 * @param arr
	 * @param maxDisplay
	 * @param expanded
	 *
	 * Used to implement the ellipsis functionality based on following conditions:
	 * if the amount of breadcrumbs is higher than the maxBreadcrumbs
	 * only the following breadcrumbs will be displayed:
	 * 1. first breadcrumb
	 * 2. breadcrumbs in between the range of maxBreadcrumbs to length of the array of breadcrumbs
	 *
	 * @default 4
	 * @min 2
	 * @example maxBreadcrumbs = 4
	 * breadcrumbs = [1,2,3,4,5,6,7,8,9,10]
	 * following breadcrumbs will be displayed:
	 * 1, ... , 8, 9, 10
	 */
	transform(arr: Array<Breadcrumb>, maxDisplay: number, expanded?: boolean): any[] {
		if (!arr) return [];
		if (arr.length <= maxDisplay || maxDisplay < 1 || expanded) return arr;
		if (maxDisplay === 1) {
			return arr.map((item, index) => (index < arr.length - 1 ? '...' : item));
		}
		return [arr[0], '...', ...arr.slice(-maxDisplay + 1)];
	}
}
